import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';

// Components
import { BlurView } from 'expo-blur';
import { VStack, HStack } from 'native-base';
import { TabBarButton, TabBarButtonType } from '@breakroom-nx/ui';

import {
  useAppSelector,
  getChatRoomPanelState,
  openModal,
  useAppDispatch,
  useGetCurrentUserQuery,
  useGetUserNotificationsQuery,
  useGetUnreadChatsCountQuery,
  useGetCurrentUserAccountStatesQuery,
} from '@breakroom-nx/redux';

import { PermissionStatus } from '@breakroom-nx/helpers';

function TabNavigationContainer() {
  const auth = getAuth();
  const dispatch = useAppDispatch();
  const chatRoomPaneDisplayed = useAppSelector(getChatRoomPanelState);

  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const [seenNotificationIds, setSeenNotificationIds] = useState<Set<string>>(
    new Set()
  );

  const { data: currentUser, isLoading: isLoadingUser } =
    useGetCurrentUserQuery();
  const { data: unreadChats, isLoading: isLoadingUnreadChats } =
    useGetUnreadChatsCountQuery(null);
  const {
    data: notifications,
    isLoading: isLoadingNotifications,
    isSuccess,
    isError,
    error,
    currentData,
    isFetching,
    refetch,
  } = useGetUserNotificationsQuery();

  // Calculate unread notifications count
  const unreadNotificationsCount = notifications
    ? notifications.filter((n) => !n.read).length
    : 0;

  const { data: accountStates, isLoading: isLoadingAccountStates } =
    useGetCurrentUserAccountStatesQuery();

  // Show browser notifications for new notifications (assume permission already handled)
  // useEffect(() => {
  //   if (
  //     initialFetchDone &&
  //     notifications &&
  //     Array.isArray(notifications) &&
  //     Notification.permission === 'granted'
  //   ) {
  //     const newNotifications = notifications.filter(
  //       (n) => n.uid && !seenNotificationIds.has(n.uid)
  //     );
  //     newNotifications.forEach((n) => {
  //       new Notification(n.type || 'New Notification', {
  //         body: n.text || '',
  //       });
  //     });
  //     if (newNotifications.length > 0) {
  //       setSeenNotificationIds((prev) => {
  //         const updated = new Set(prev);
  //         newNotifications.forEach((n) => updated.add(n.uid));
  //         return updated;
  //       });
  //     }
  //   }
  // }, [notifications, initialFetchDone, seenNotificationIds]);

  // useEffect(() => {
  //   if (notifications) {
  //     console.log(`Notifications: ${notifications}`);
  //     const notification = notifications[0];
  //     new Notification(notification.type || 'New Notification', {
  //       body: notification.text || '',
  //     });
  //   }
  // }, [notifications]);

  useEffect(() => {
    if (initialFetchDone && notifications !== undefined) {
      // console.log(`Data Updated!`);
      // You can perform any actions needed when new data arrives
    }
  }, [notifications]);

  useEffect(() => {
    if (initialFetchDone) {
      // console.log(`Data Updated 1!`);
      // You can perform any actions needed when new data arrives
    } else {
      // Mark initial fetch as done after the first successful fetch
      if (!isLoadingNotifications && !error) {
        setInitialFetchDone(true);
      }
    }
  }, [initialFetchDone]);

  useEffect(() => {
    // console.log(`Rendering Tab Navigation Container`);
  });

  useEffect(() => {
    // console.log(`[Home] Loading account states for client`);

    if (accountStates) {
      if (!accountStates.completedOnboarding) {
        dispatch(openModal({ modalType: 'ProfileSetup' }));
      } else if (
        accountStates.cookiePermissions === PermissionStatus.NotSet ||
        accountStates.notificationPermissions === PermissionStatus.NotSet ||
        accountStates.locationPermissions === PermissionStatus.NotSet
      ) {
        dispatch(openModal({ modalType: 'PermissionsContainer' }));
      }
    }
  }, [accountStates]);

  return (
    <VStack
      margin={'auto'}
      marginBottom={{ base: '1rem', lg: '2rem' }}
      style={{
        alignItems: 'center',
        justifyContent: 'flex-end',
        zIndex: 9999999,
      }}
      display={{
        base: chatRoomPaneDisplayed ? 'none' : 'flex',
        lg: 'flex',
      }}
    >
      <BlurView intensity={25} tint={'dark'} style={{ borderRadius: 50 }}>
        <HStack space={4}>
          <TabBarButton
            type={TabBarButtonType.Chat}
            badgeValue={unreadChats}
            isLoading={isLoadingUser || isLoadingUnreadChats}
          />
          <TabBarButton
            type={TabBarButtonType.Randomizer}
            isLoading={isLoadingUser}
          />
          <TabBarButton
            type={TabBarButtonType.Profile}
            badgeValue={unreadNotificationsCount}
            user={currentUser}
            isAnonymous={auth.currentUser?.isAnonymous ?? false}
            isLoading={
              isLoadingUser ||
              auth.currentUser === undefined ||
              isLoadingNotifications
            }
          />
        </HStack>
      </BlurView>
    </VStack>
  );
}

export default React.memo(TabNavigationContainer);
